import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { correiosUrl } from "@/lib/shipments";
import { copyText } from "@/lib/proposal";

// Código dos Correios: copia e abre o rastreio oficial.
export const TrackCorreios = ({ code }) => {
  if (!code) return null;
  const open = () => {
    copyText(code);
    window.open(correiosUrl(code), "_blank", "noopener");
  };
  return (
    <div data-testid="track-correios" className="flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-xs uppercase tracking-[0.14em] text-zinc-400">Rastreio dos Correios</p>
        <p data-testid="track-correios-code" className="mono mt-1 text-lg font-semibold tracking-wider text-white">{code}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <button type="button" data-testid="track-correios-copy" onClick={() => copyText(code).then(() => toast.success("Código copiado"))}
          className="flex items-center gap-1.5 rounded-full border border-white/15 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"><Copy className="h-4 w-4" /> Copiar</button>
        <button type="button" data-testid="track-correios-open" onClick={open}
          className="keep-color flex items-center gap-1.5 rounded-full bg-[#FFD400] px-4 py-2.5 text-sm font-semibold text-[#0a2a5e] transition-transform hover:scale-[1.03]"><ExternalLink className="h-4 w-4" /> Rastrear nos Correios</button>
      </div>
    </div>
  );
};
